/* eslint no-console:0 */

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
import React from 'react';
import { mountReactApp } from '../helpers/mountReactApp';
import MakeCartPage from '../components/Form/MakeCartPage';

var el = document.getElementById('make-container');
const shopPath = el.dataset.shopPath || '/shop/ring/brass/7';

mountReactApp(
  el.appendChild(document.createElement('div')),
  <MakeCartPage shopPath={shopPath}/>,
);
